import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import "./admin.css";

const USERNAME_HINT = process.env.REACT_APP_ADMIN_USERNAME || "admin";
const PASSWORD_HINT = process.env.REACT_APP_ADMIN_PASSWORD || "mehmet1234";

export default function AdminLogin() {
  const { isAuthenticated, validateCredentials } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState(USERNAME_HINT);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/admin", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    const result = await validateCredentials(username, password);

    if (result.success) {
      const redirectTo = location.state?.from?.pathname ?? "/admin";
      navigate(redirectTo, { replace: true });
    } else {
      setError(result.message || "Giriş yapılamadı. Lütfen tekrar deneyin.");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__panel">
        <div className="admin-login__header">
          <span className="admin-login__badge">Modelerman</span>
          <h1 className="admin-login__title">İçerik paneline giriş</h1>
          <p className="admin-login__subtitle">Yetkili kullanıcılar için giriş ekranı.</p>
        </div>

        <form className="admin-login__form" onSubmit={handleSubmit}>
          <label className="admin-login__label" htmlFor="username">
            Kullanıcı adı
          </label>
          <input
            id="username"
            type="text"
            className="admin-login__input"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
            placeholder="admin"
            required
          />

          <label className="admin-login__label" htmlFor="password">
            Şifre
          </label>
          <input
            id="password"
            type="password"
            className="admin-login__input"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            placeholder="••••••••"
            required
          />

          {error && <p className="admin-login__error">{error}</p>}

          <button type="submit" className="admin-login__submit" disabled={isSubmitting}>
            {isSubmitting ? "Kontrol ediliyor..." : "Giriş yap"}
          </button>
        </form>

        <p className="admin-login__hint">
          Yetkilendirilmiş kullanıcılar için demo kimlik bilgileri: {USERNAME_HINT} / {PASSWORD_HINT}
        </p>
      </div>
    </div>
  );
}
